import React, { useEffect, useRef, useState } from "react";
import * as echarts from "echarts";
import AADService from "../funcionesAuth.js";
import { Row, Col } from "react-bootstrap";
import CheckRole from "../CheckRole.js";
import { DecryptData } from "../DatosEncriptados/EncryptedFunctions";

const EfectosPropios = () => {
  const AzureADService = new AADService();
  const token = AzureADService.getToken();
  // Estado principal
  const [notificationRequired, setNotificationRequired] = useState("");
  const [devType, setDevType] = useState("");
  const [securityImpacts, setSecurityImpacts] = useState([]);
  const [notifyMedia, setNotifyMedia] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  
  // Recuperación
  const [maquinasReposicion, setMaquinasReposicion] = useState("");
  const [softwareValor, setSoftwareValor] = useState("");
  const [anioVersion, setAnioVersion] = useState("");
  const [RecuperacionValor, setRecuperacionValor] = useState("");
  let tipoDespliegue = localStorage.getItem("variable_tipo_despliegue");
  const despliegues = tipoDespliegue.split(",");
  const check = new CheckRole("/AutoevaluacionAplicacion");
  const [opcionesGenerales, setOpcionesGenerales] = React.useState([]);
  const SaveIcon = () => (
    <svg
      width="25"
      height="25"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
      <polyline points="17,21 17,13 7,13 7,21" />
      <polyline points="7,3 7,8 15,8" />
    </svg>
  );
  const globalSaveButtonStyle = {
    backgroundColor: "#00C389",
    color: "white",
    border: "none",
    borderRadius: "8px",
    padding: "12px 24px",
    fontSize: "1.5rem",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    transition: "all 0.3s ease",
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
  };
  // Parámetros de escenario
  const [valores, setValores] = useState({
    maximo: "",
    realista: "",
    minimo: "",
  });
  const guardarAutoevaluacion = async () => {
    if (notificationRequired === "si") {
      const triadaIniciales = securityImpacts.map((item) =>
        item.charAt(0).toUpperCase()
      );
      const poblacion = [
        valores.minimo,
        valores.realista,
        valores.maximo,
        selectedOption,
      ];
      // Validaciones
      if (notifyMedia.length === 0) {
        alert("Debe seleccionar al menos un medio de notificación.");
        return;
      }
      if (securityImpacts.length === 0) {
        alert("Debe seleccionar al menos un principio de seguridad.");
        return;
      }
      if (!valores.maximo || !valores.realista || !valores.minimo) {
        alert("Debe completar todos los valores de población.");
        return;
      }

      if (
        isNaN(Number(valores.minimo)) ||
        isNaN(Number(valores.realista)) ||
        isNaN(Number(valores.maximo))
      ) {
        alert("Todos los valores deben ser números.");
        return;
      }

      if (
        !(
          Number(valores.minimo) < Number(valores.realista) &&
          Number(valores.realista) < Number(valores.maximo)
        )
      ) {
        alert("Las poblaciones deben cumplir: mínima < realista < máxima.");
        return;
      }
      if (!selectedOption) {
        alert("Debe seleccionar una opción de población.");
        return;
      }

      const mediaMap = {
        Email: "email",
        SMS: "sms",
        "Mensajería física": "fisico",
        "Call center": "call",
      };

      const mediosConvertidos = notifyMedia.map((item) => mediaMap[item]);
      // Construir JSON
      const payload = {
        notificacion: {
          medios: mediosConvertidos,
          triada: triadaIniciales,
          poblacion: poblacion,
        },
        recuperacion: {},
        normalizacion: {},
      };
      alert("JSON generado:\n" + JSON.stringify(payload, null, 2));

      fetch(process.env.REACT_APP_API_URL +
          "activoAutoevaluacion/"+localStorage.getItem("idcompania")+"/"+localStorage.getItem("idactivo")+"/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((data) => alert("Autoevaluación guardada"))
        .catch((err) => alert("Error al guardar autoevaluacion"));
    }
  };

  // Helpers
  const toggleArray = (arr, val) =>
    arr.includes(val) ? arr.filter((v) => v !== val) : [...arr, val];

  useEffect(() => {
    
    const fetchUsuario = async () => {
          const result = await fetch(
            process.env.REACT_APP_API_URL +
              "usuarios/menu/" +
              localStorage.getItem("usuario") +
              "/",
            {
              method: "GET",
              headers: {
                Accept: "application/json",
                Authorization: "Bearer " + token,
              },
            }
          );
          const encryptedUser = await result.json();
          const decryptedUser = DecryptData(encryptedUser);
          let usuario = JSON.parse(decryptedUser);
          let opciones = [];
          let permisos = [];
          for (let i = 0; i < usuario.length; i++) {
            permisos = usuario[i].permisos.split(";");
            opciones.push({ opcion: usuario[i].url_opcion, permisos: permisos });
          }
          setOpcionesGenerales(opciones);
        };
    fetchUsuario();
    if (notificationRequired !== "si") {
      setSecurityImpacts([]);
      setNotifyMedia([]);
    }
  }, [notificationRequired]);

  return (
    <>
      <style>{`
        .ep-wrapper {
          max-width: 1200px;
          margin: 60px auto;
          padding: 48px;
          background: #f7f7f7;
          border-radius: 32px;
          box-shadow: 0 12px 48px rgba(40,40,40,0.10);
          display: flex;
          flex-direction: column;
          gap: 56px;
        }
        .ep-section {
          background: #fff;
          border-radius: 24px;
          box-shadow: 0 4px 24px rgba(40,40,40,0.08);
          padding: 36px;
          border: 1px solid #e0e0e0;
          width: 100%; /* Asegura que el padre ocupe todo el espacio disponible */
        }
        .ep-title {
          font-size: 2rem;
          font-weight: 700;
          color: #222;
          margin-bottom: 24px;
        }
        .ep-label {
          font-weight: 600;
          color: #222;
          margin-bottom: 12px;
          display: block;
          font-size: 1.2rem;
        }
        .ep-input, .ep-select {
          width: 100%;
          padding: 16px 20px;
          border: 1.5px solid #bbb;
          border-radius: 12px;
          background: #f1f1f1;
          margin-top: 6px;
          font-size: 1.2rem;
          transition: border 0.2s;
          color: #222;
        }
        .ep-input:focus, .ep-select:focus {
          border-color: #444;
          outline: none;
          background: #eaeaea;
        }
        .ep-checkbox-group {
          display: flex;
          gap: 32px;
          margin-top: 12px;
        }
        .ep-checkbox-label {
          display: flex;
          align-items: center;
          gap: 10px;
          cursor: pointer;
          font-size: 1.15rem;
          color: #333;
        }
        .ep-checkbox {
          accent-color: #222;
          width: 24px;
          height: 24px;
        }
        .ep-cost-box {
          background: #ededed;
          border-radius: 16px;
          padding: 24px;
          border: 1px solid #d2d2d2;
          margin-top: 24px;
        }
        .ep-cost-total {
          text-align: right;
          font-size: 1.3rem;
          font-weight: 700;
          color: #222;
          margin-top: 12px;
        }
        .ep-chart-container {
          width: 100%;
          height: 500px;
          border: 1.5px solid #e0e0e0;
          border-radius: 18px;
          background: #f1f1f1;
        }
        .ep-grid {
          display: grid;
          gap: 32px;
        }
        .ep-grid-2 {
          grid-template-columns: repeat(2, 1fr);
        }
        .ep-grid-3 {
          grid-template-columns: repeat(3, 1fr);
        }
        .ep-small-text {
          font-size: 1.1rem;
          color: #555;
          margin-top: 12px;
        }
        .ep-header {
          text-align: center;
          margin-bottom: 32px;
        }
        .ep-main-title {
          font-size: 3rem;
          font-weight: 900;
          color: #222;
          margin-bottom: 12px;
        }
        .ep-sub-title {
          font-size: 1.3rem;
          color: #555;
        }


      `}</style>
      <div className="ep-wrapper">
        {/* SECCIÓN 1 */}
        <section className="ep-section">
          <div className="ep-title">Gastos de notificación</div>
          <label className="ep-label">
            Si la información contenida en la aplicación se ve comprometida, ¿se
            debe notificar a los propietarios de los datos?
          </label>
          <select
            className="ep-select"
            value={notificationRequired}
            onChange={(e) => setNotificationRequired(e.target.value)}
          >
            <option value="">Selecciona una opción</option>
            <option value="si">Sí</option>
            <option value="no">No</option>
          </select>
          {notificationRequired === "" && (
            <p className="ep-small-text">
              * Responde esta pregunta para continuar.
            </p>
          )}
        </section>

        {/* SECCIÓN 2: Detalle de notificación, parámetros y gráfica */}
        {notificationRequired === "si" && (
          <section className="ep-section">
            <div className="ep-title">Detalle de notificación</div>
            <label className="ep-label" style={{ marginTop: 24 }}>
              ¿Por qué medio se notificará?
            </label>
            <div className="ep-checkbox-group">
              {["Email", "SMS", "Mensajería física", "Call center"].map((m) => (
                <label className="ep-checkbox-label" key={m}>
                  <input
                    className="ep-checkbox"
                    type="checkbox"
                    checked={notifyMedia.includes(m)}
                    onChange={() =>
                      setNotifyMedia((prev) => toggleArray(prev, m))
                    }
                  />
                  {m}
                </label>
              ))}
            </div>
            <label className="ep-label">
              ¿Cuál de los principios de seguridad de la información debe verse
              comprometido para que se considere necesario notificar? (Selección
              multiple)
            </label>
            <div className="ep-checkbox-group">
              {[
                {
                  label: "Confidencialidad",
                  description:
                    "Si la información de la aplicación ha sido robada o divulgada externamente.",
                },
                {
                  label: "Integridad",
                  description:
                    "Si la información del sistema ha sido alterada, modificada o se ha creado información falsa.",
                },
                {
                  label: "Disponibilidad",
                  description:
                    "Si no es posible acceder al sistema o la información de este.",
                },
              ].map(({ label, description }) => (
                <label
                  className="ep-checkbox-label"
                  key={label}
                  style={{ display: "block", marginBottom: "8px" }}
                >
                  <input
                    className="ep-checkbox"
                    type="checkbox"
                    checked={securityImpacts.includes(label)}
                    onChange={() =>
                      setSecurityImpacts((prev) => toggleArray(prev, label))
                    }
                  />

                  <span
                    style={{
                      fontWeight: "bold",
                      marginLeft: "10px",
                      position: "relative",
                      top: "-6px",
                    }}
                  >
                    {label}
                  </span>

                  <div
                    style={{
                      fontSize: "0.85em",
                      color: "#666",
                      marginLeft: "28px",
                    }}
                  >
                    {description}
                  </div>
                </label>
              ))}
            </div>
            {/* Parámetros de escenario */}
            <div className="ep-cost-box">
              <p className="ep-small-text">
                Para poder definir adecuadamente los costos de comunicación ante
                un evento de ciberseguridad, necesitamos entender cuál sería la
                población objetivo que debería ser notificada. Para esto, te
                pedimos que estimes tres escenarios posibles:
              </p>
              <ul>
                <li>
                  <strong>Población mínima:</strong> El número mínimo de
                  personas, que, por su sensibilidad, por la criticidad de los
                  datos comprometidos deberían ser notificados.
                </li>
                <li>
                  <strong>Población realista:</strong> Un escenario intermedio
                  que contempla personas con información completa, estados
                  activos, saldos disponibles u otra variable que permita
                  filtrar población con potencial riesgo de daño a ser
                  notificada.
                </li>
                <li>
                  <strong>Población máxima:</strong> Puede estar representado
                  por el total de propietarios de información contenida en la
                  aplicación (independiente del estado de la información)
                </li>
              </ul>
              <div className="ep-grid ep-grid-3">
                <div>
                  <label className="ep-label">Población mínima</label>
                  <input
                    className="ep-input"
                    type="number"
                    value={valores.minimo}
                    onChange={(e) =>
                      setValores((v) => ({ ...v, minimo: e.target.value }))
                    }
                    placeholder="Ej: 20"
                  />
                </div>
                <div>
                  <label className="ep-label">Población realista</label>
                  <input
                    className="ep-input"
                    type="number"
                    value={valores.realista}
                    onChange={(e) =>
                      setValores((v) => ({ ...v, realista: e.target.value }))
                    }
                    placeholder="Ej: 60"
                  />
                </div>
                <div>
                  <label className="ep-label">Población máxima</label>
                  <input
                    className="ep-input"
                    type="number"
                    value={valores.maximo}
                    onChange={(e) =>
                      setValores((v) => ({ ...v, maximo: e.target.value }))
                    }
                    placeholder="Ej: 100"
                  />
                </div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 24,
                marginBottom: 14,
                marginTop: 14,
              }}
            >
              <label
                htmlFor="chart-select"
                className="ep-label"
                style={{ marginBottom: 0 }}
              >
                Según tu conocimiento del funcionamiento de la aplicación, ¿cuál
                de los escenarios anteriores consideras más probable?
              </label>
              <select
                className="ep-select"
                id="chart-select"
                value={selectedOption}
                onChange={(e) => setSelectedOption(e.target.value)}
                style={{ width: 280 }}
              >
                <option value="">Seleccione una población</option>
                <option value="min">Población Mínima</option>
                <option value="rea">Población Realista</option>
                <option value="max">Población Máxima</option>
              </select>
            </div>
          </section>
        )}

        {/* SECCIÓN 3 */}
        <section className="ep-section">
          <div className="ep-grid ep-grid-2">
            <div class="ep-title" style={{ gridColumn: "1 / span 2" }}>
              Gastos de normalización
            </div>

            {despliegues.includes("OnPremise") ? (
              <>
                <div
                  className="ep-subgrid"
                  style={{
                    gridColumn: "1 / span 2",
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "16px",
                  }}
                >
                  <div class="ep-label">
                    ¿Cuánto valdría reponer los equipos sobre los cuales está
                    soportada la operación de la aplicación?
                  </div>
                  <input
                    className="ep-input"
                    type="number"
                    min="0"
                    value={maquinasReposicion}
                    onChange={(e) => setMaquinasReposicion(e.target.value)}
                    placeholder="Ej: 12000000"
                  />
                </div>
                <div
                  className="ep-subgrid"
                  style={{
                    gridColumn: "1 / span 2",
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "16px",
                  }}
                >
                  <div class="ep-label">
                    ¿El software de la aplicación se compró con licencia o fue
                    desarrollado por equipo interno?
                  </div>
                  <select
                    className="ep-select"
                    value={devType}
                    onChange={(e) => setDevType(e.target.value)}
                  >
                    <option value="">Selecciona una opción</option>
                    <option value="licencia">Software licenciado</option>
                    <option value="desarrollo">Desarrollo interno</option>
                  </select>
                </div>
                {devType === "" ? (
                  <>
                    <p className="ep-small-text">
                      * Responde esta pregunta para continuar.
                    </p>
                    <br></br>
                  </>
                ) : devType === "licencia" ? (
                  <>
                    <div
                      className="ep-subgrid"
                      style={{
                        gridColumn: "1 / span 2",
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "16px",
                      }}
                    >
                      <div class="ep-label">
                        ¿Cuál es el valor de la licencia?
                      </div>
                      <input
                        className="ep-input"
                        type="number"
                        min="0"
                        value={softwareValor}
                        onChange={(e) => setSoftwareValor(e.target.value)}
                        placeholder="Ej: 3500000"
                      />
                    </div>
                    <div
                      className="ep-subgrid"
                      style={{
                        gridColumn: "1 / span 2",
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "16px",
                      }}
                    >
                      <div class="ep-label">
                        ¿De qué año es la versión de la licencia actual?
                      </div>
                      <input
                        className="ep-input"
                        type="number"
                        min="1990"
                        max={new Date().getFullYear()}
                        value={anioVersion}
                        onChange={(e) => setAnioVersion(e.target.value)}
                        placeholder={`Ej: ${new Date().getFullYear() - 1}`}
                      />
                    </div>
                  </>
                ) : devType === "desarrollo" ? (
                  <>
                    <div
                      className="ep-subgrid"
                      style={{
                        gridColumn: "1 / span 2",
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "16px",
                      }}
                    >
                      <div class="ep-label">
                        ¿Cuál fue el valor del desarrollo?
                      </div>
                      <input
                        className="ep-input"
                        type="number"
                        min="0"
                        value={softwareValor}
                        onChange={(e) => setSoftwareValor(e.target.value)}
                        placeholder="Ej: 3500000"
                      />
                    </div>
                  </>
                ) : null}
              </>
            ) : despliegues.includes("Nube") |
              despliegues.includes("IaaS") |
              despliegues.includes("PaaS") ? (
              <>
                <div
                  className="ep-subgrid"
                  style={{
                    gridColumn: "1 / span 2",
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "16px",
                  }}
                >
                  <div class="ep-label">
                    ¿El software de la aplicación se compró con licencia o fue
                    desarrollado por equipo interno?
                  </div>
                  <select
                    className="ep-select"
                    value={devType}
                    onChange={(e) => setDevType(e.target.value)}
                  >
                    <option value="">Selecciona una opción</option>
                    <option value="licencia">Software licenciado</option>
                    <option value="desarrollo">Desarrollo interno</option>
                  </select>
                </div>
                {devType === "" ? (
                  <>
                    <p className="ep-small-text">
                      * Responde esta pregunta para continuar.
                    </p>
                    <br></br>
                  </>
                ) : devType === "licencia" ? (
                  <>
                    <div
                      className="ep-subgrid"
                      style={{
                        gridColumn: "1 / span 2",
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "16px",
                      }}
                    >
                      <div class="ep-label">
                        ¿Cuál es el valor de la licencia?
                      </div>
                      <input
                        className="ep-input"
                        type="number"
                        min="0"
                        value={softwareValor}
                        onChange={(e) => setSoftwareValor(e.target.value)}
                        placeholder="Ej: 3500000"
                      />
                    </div>
                    <div
                      className="ep-subgrid"
                      style={{
                        gridColumn: "1 / span 2",
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "16px",
                      }}
                    >
                      <div class="ep-label">
                        ¿De qué año es la versión de la licencia actual?
                      </div>
                      <input
                        className="ep-input"
                        type="number"
                        min="1990"
                        max={new Date().getFullYear()}
                        value={anioVersion}
                        onChange={(e) => setAnioVersion(e.target.value)}
                        placeholder={`Ej: ${new Date().getFullYear() - 1}`}
                      />
                    </div>
                  </>
                ) : devType === "desarrollo" ? (
                  <>
                    <div
                      className="ep-subgrid"
                      style={{
                        gridColumn: "1 / span 2",
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "16px",
                      }}
                    >
                      <div class="ep-label">
                        ¿Cuál fue el valor del desarrollo?
                      </div>
                      <input
                        className="ep-input"
                        type="number"
                        min="0"
                        value={softwareValor}
                        onChange={(e) => setSoftwareValor(e.target.value)}
                        placeholder="Ej: 3500000"
                      />
                    </div>
                  </>
                ) : null}
              </>
            ) : despliegues.includes("SaaS") ? (
              <br></br>
            ) : (
              <label className="ep-label">
                Sin Esquema de despliegue valido
              </label>
            )}
          </div>
        </section>
        {check.checkPermits(opcionesGenerales, "POST") ? (
        <button
          style={globalSaveButtonStyle}
          onClick={guardarAutoevaluacion}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "#047857";
            e.target.style.transform = "translateY(-2px)";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "#00C389";
            e.target.style.transform = "translateY(0px)";
          }}
        >
          <SaveIcon />
          Guardar Autoevaluación
        </button>
        ) : ("")}
      </div>
    </>
  );
};

export default EfectosPropios;
